import { render } from "./BaseCard.vue?vue&type=template&id=7de627f3&scoped=true"
const script = {}

import "./BaseCard.vue?vue&type=style&index=0&id=7de627f3&scoped=true&lang=scss"

import exportComponent from "/builds/digithia/escape-game/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7de627f3"]])

export default __exports__